import { render, staticRenderFns } from "./CmgTaxAndFees.vue?vue&type=template&id=7897b1c4&scoped=true&lang=pug"
import script from "./cmg-tax-and-fees.ts?vue&type=script&lang=ts&external"
export * from "./cmg-tax-and-fees.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgTaxAndFees.vue?vue&type=style&index=0&id=7897b1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897b1c4",
  null
  
)

export default component.exports